module.exports = __webpack_public_path__ + "static/media/group-all-off.54bbd6fc.svg";